import { Injectable, Inject, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { REQUEST_HEADERS } from './../../tokens'; // Import the custom token

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private requestHeaders = inject(REQUEST_HEADERS, { optional: true });
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getHeader(headerName: string): string | null {
    if (isPlatformServer(this.platformId)) {
      if(this.requestHeaders){
        return this.requestHeaders[headerName.toLowerCase()] || null;
      }
    }
    return null; // Client-side won't have access to headers
  }
}
